import { render, staticRenderFns } from "./personalEdit.vue?vue&type=template&id=54bcb778&scoped=true&"
import script from "./personalEdit.vue?vue&type=script&lang=js&"
export * from "./personalEdit.vue?vue&type=script&lang=js&"
import style0 from "./personalEdit.vue?vue&type=style&index=0&id=54bcb778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcb778",
  null
  
)

export default component.exports